import { userActionTypes } from "./user.action.types";

const initState = {
  token: localStorage.getItem('authToken'),
  userId: null,
  currentUser: null,
  isAuthenticated: null,
  isLoading: true,
  authError: null,
};

const userReducer = (state = initState, { type, payload }) => {
  switch (type) {
    case userActionTypes.SIGN_UP:
      return {
        ...state,
        isLoading: false,
        currentUser: payload

      };
    case userActionTypes.LOG_IN:
      return {
        ...state,
        isLoading: false,
        currentUser: payload

      };
    case userActionTypes.LOG_OUT:
      return {
        ...state,
        currentUser: null,
        isLoading: false,
        isAuthenticated: false
      };
    case userActionTypes.SET_CURRENT_USER:
      return {
        ...state,
        currentUser: payload,
        isLoading: false,
      };
    case userActionTypes.AUTH_ERROR:
      return {
        ...state,
        authError: payload,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default userReducer;
